import React from 'react';
import cx from 'classnames';
import { OutlineButton } from '../../../components/Button';
import styles from '../Transactions.module.css';
import { TRANSACTION_STATUS } from '../utils/types';

interface StatusProps {
  type: number;
  onFinish: () => void;
}

const buttonClassName = cx('flex justify-center items-center pa0 f12', styles.closeOrderButton);

export const Status = ({ type, onFinish }: StatusProps) => {
  switch (type) {
    case TRANSACTION_STATUS.PAID: {
      return <span className="grass-green">Concluída</span>;
    }
    case TRANSACTION_STATUS.CANCELED: {
      return <span className="purpley-pink">Cancelada</span>;
    }
    case TRANSACTION_STATUS.ON_DISPUTE: {
      return <>Em disputa</>;
    }
    case TRANSACTION_STATUS.AWAITING_PAYMENT: {
      return <>Aguardando pagamento</>;
    }
    case TRANSACTION_STATUS.RETURNED: {
      return <>Devolvida</>;
    }
    case TRANSACTION_STATUS.AVAILABLE: {
      return <>Disponível</>;
    }
    case TRANSACTION_STATUS.ON_HOLD: {
      return <>Retenção temporária</>;
    }
    case TRANSACTION_STATUS.DEBITED: {
      const buttonProps = {
        onClick: onFinish,
        resetPadding: true,
        heightAuto: true,
        className: buttonClassName,
      };
      return (
        <OutlineButton {...buttonProps}>
          <p className="f12 trueno fw6 ma0">FINALIZAR</p>
        </OutlineButton>
      );
    }
    default:
      return <>Em análise</>;
  }
};
